export const verifyAddressPopupCustomStyle = `
  .verify-address-popup__button-list-wrapper {
    list-style: none;
    padding: 0;
  }
`;
